import { useState } from 'react';
import { Header } from '@/components/Header';
import { AppCard } from '@/components/AppCard';
import { useApps } from '@/hooks/useApps';
// import { useAnalytics } from '@/hooks/useAnalytics';
import { Search, Star } from 'lucide-react';
import { Input } from '@/components/Input';
// import { Button } from '@/components/Button';
// import { Grid3x3, TrendingUp } from 'lucide-react';

// type View = 'apps' | 'analytics';

export function DashboardPage() {
  const { apps, favorites, loading, toggleFavorite, logAccess } = useApps();
  const [searchQuery, setSearchQuery] = useState('');
  // const [view, setView] = useState<View>('apps');

  const filteredApps = apps.filter(app =>
    app.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    app.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    app.category?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAppAccess = async (appId: string, _url: string) => {
    await logAccess(appId);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <Header />
        <main className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />

      <main className="container mx-auto px-4 py-8">
        {/* Analytics view hidden for now — re-enable when analytics work resumes */}
        {/* <div className="flex gap-2 mb-6">
          <Button
            variant={view === 'apps' ? 'primary' : 'ghost'}
            onClick={() => setView('apps')}
            className="gap-2"
          >
            <Grid3x3 className="w-4 h-4" />
            Applications
          </Button>
          <Button
            variant={view === 'analytics' ? 'primary' : 'ghost'}
            onClick={() => setView('analytics')}
            className="gap-2"
          >
            <TrendingUp className="w-4 h-4" />
            Analytics
          </Button>
        </div> */}

        {/* {view === 'apps' ? ( */}
          <>
            {/* Search Bar */}
            <div className="mb-8 max-w-2xl">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                <Input
                  type="text"
                  placeholder="Search applications..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>

            {/* Favorites Section */}
            {favorites.length > 0 && !searchQuery && (
              <section className="mb-12">
                <div className="flex items-center gap-2 mb-4">
                  <Star className="w-5 h-5 text-yellow-500 fill-current" />
                  <h2 className="text-2xl font-bold">Favorites</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {favorites.map(app => (
                    <AppCard
                      key={app.id}
                      app={app}
                      onToggleFavorite={toggleFavorite}
                      onAccess={handleAppAccess}
                    />
                  ))}
                </div>
              </section>
            )}

            {/* All Apps Section */}
            <section>
              <h2 className="text-2xl font-bold mb-4">
                {searchQuery ? 'Search Results' : 'All Applications'}
              </h2>

              {filteredApps.length === 0 ? (
                <div className="text-center py-12">
                  <div className="text-gray-600 dark:text-gray-400 text-lg">
                    {searchQuery ? 'No applications found matching your search.' : 'No applications available.'}
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {filteredApps.map(app => (
                    <AppCard
                      key={app.id}
                      app={app}
                      onToggleFavorite={toggleFavorite}
                      onAccess={handleAppAccess}
                    />
                  ))}
                </div>
              )}
            </section>
          </>
        {/* ) : (
          <AnalyticsView />
        )} */}
      </main>
    </div>
  );
}

// Analytics View Component - hidden for now
/*
function AnalyticsView() {
  const { stats, logs, loading } = useAnalytics();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  const hasStats = stats && stats.length > 0;
  const hasLogs = logs && logs.length > 0;

  return (
    <div className="space-y-8">
      <section>
        <h3 className="text-xl font-bold mb-4">Usage Statistics</h3>
        {hasStats ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {stats.map((stat: any) => (
              <div
                key={stat.appId}
                className="p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm"
              >
                <h3 className="font-semibold text-lg mb-2">{stat.appName}</h3>
                <p className="text-3xl font-bold text-primary-600 mb-1">
                  {stat.accessCount}
                </p>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Last accessed: {new Date(stat.lastAccessedAt).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 border border-gray-200 dark:border-gray-700 rounded-xl">
            <TrendingUp className="w-12 h-12 mx-auto mb-4 text-gray-400" />
            <p className="text-gray-600 dark:text-gray-400">
              No usage data yet. Click on some apps to generate analytics!
            </p>
          </div>
        )}
      </section>

      <section>
        <h3 className="text-xl font-bold mb-4">Recent Activity</h3>
        {hasLogs ? (
          <div className="space-y-2">
            {logs.map((log: any, index: number) => (
              <div
                key={`${log.timestampAppId}-${index}`}
                className="flex items-center justify-between p-4 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
              >
                <div>
                  <p className="font-medium">{log.appId}</p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {new Date(log.accessedAt).toLocaleString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 border border-gray-200 dark:border-gray-700 rounded-xl">
            <p className="text-gray-600 dark:text-gray-400">
              No recent activity. Start by accessing some apps!
            </p>
          </div>
        )}
      </section>
    </div>
  );
}
*/
